import { Component, OnInit, Input } from '@angular/core';

import { ICampaign } from '@interfaces/campaigns';
import { FirebaseService } from '@services/firebase/firebase.service';
import { NavigationService } from '@services/navigation/navigation.service';

@Component({
  selector: 'app-firebase-campaign-banner',
  templateUrl: './firebase-campaign-banner.component.html',
  styleUrls: ['./firebase-campaign-banner.component.scss'],
})
export class FirebaseCampaignBannerComponent implements OnInit {

  @Input() campaignId: string;
  campaign: ICampaign;
  bgLoaded = false;
  firebaseDelayReady = false;
  campaignIsActive: boolean;

  constructor(
    private firebaseService: FirebaseService,
    private navigationService: NavigationService,
  ) { }

  ngOnInit() {
    const campaigns = this.firebaseService.getCollection(`campaigns`);
    this.firebaseService.getDocument(this.campaignId, campaigns).then((campaign: ICampaign) => {
      this.campaign = campaign;
      this.campaignIsActive = true;
      if (campaign && campaign.loadingBannerTimeout) {
        setTimeout(() =>  {
          this.firebaseDelayReady = true;
        }, (campaign && campaign.loadingBannerTimeout) || 0);
      } else {
        this.firebaseDelayReady = true;
      }
      if (campaign && !campaign.bannerBGImage) {
        this.bgLoaded = true;
      }
    }).catch(error => this.campaignIsActive = false);
  }

  clickedBanner() {
    this.firebaseService.logEvent('clicked_campaign_banner', {}, true);
    this.firebaseService.logEvent('firebase_campaign_' + this.campaignId.replace(/-/g, '_'), {}, true);
    if (this.campaign && this.campaign.pageOnClick) {
      if (this.campaign.pageOnClick.startsWith('http')) {
        this.navigationService.openInBrowser(this.campaign.pageOnClick);
      } else {
        this.navigationService.goTo(this.campaign.pageOnClick);
      }
    }
  }

}
